import { useState } from 'react';
import { userInfoSync } from 'hub-http/userInfo';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FOCUS_RING_BASE } from 'HubStyleTokens/colors';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import UIFormLabel from 'UIComponents/form/UIFormLabel';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIButton from 'UIComponents/button/UIButton';
import UIDropdownCaret from 'UIComponents/dropdown/UIDropdownCaret';
import { getEncodedValue, getDecodedContent, openPersonalizePopover } from 'tinymce-config/utils/handlers';
import { getConfig } from 'tinymce-config/configs/editors/personalization-field';
// @ts-expect-error untyped module react-tinymce
import TinyMCE from 'react-tinymce';
import { CONTACT_FQN } from 'rich-text-lib/constants/properties';
import Routes from 'ContentUtils/Routes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const KEY = 'HS_EMAIL_EDITOR_SUBJECT_FIELD';
const i18nKey = key => `ContentComponents.cmv2.fields.form.formWorkflowDependencies.followupEmailWorkflows.emailEditorPanel.subject.${key}`;
const RichTextEditorWrapper = styled.div.withConfig({
  displayName: "SubjectField__RichTextEditorWrapper",
  componentId: "sc-1hdgar8-0"
})([".mce-content-body:focus{border-color:rgba(0,208,228,0.5);box-shadow:0 0 4px 1px rgba(0,208,228,0.3),0 0 0 1px ", ";outline:0;}"], FOCUS_RING_BASE);
const SubjectField = ({
  onChange,
  pickerComponents,
  value
}) => {
  const [config, setConfig] = useState();
  const [editor, setEditor] = useState();
  const {
    user
  } = userInfoSync();
  const _getConfig = () => {
    if (config) return config;
    const _config = getConfig({
      appName: 'page-editor',
      gates: Routes.gates,
      scopes: user.scopes,
      includeSiteSettings: false,
      includeSubscriptionType: false,
      pickerComponents,
      supportedCrmObjectFQNs: [CONTACT_FQN],
      isMultiline: true
    });
    setConfig(_config);
    return _config;
  };
  return /*#__PURE__*/_jsx(UIFormControl, {
    label: /*#__PURE__*/_jsx(UIMediaObject, {
      itemRight: /*#__PURE__*/_jsxs(UIButton, {
        use: "transparent",
        className: "p-all-0",
        onClick: () => {
          if (editor) {
            openPersonalizePopover(editor);
          }
        },
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "contacts"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('contactToken')
        }), /*#__PURE__*/_jsx(UIDropdownCaret, {
          className: "m-left-1"
        })]
      }),
      children: /*#__PURE__*/_jsx(UIFormLabel, {
        className: "p-all-0",
        required: true,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('label')
        })
      })
    }),
    labelClassName: "p-right-0",
    children: /*#__PURE__*/_jsx(RichTextEditorWrapper, {
      children: /*#__PURE__*/_jsx(TinyMCE, {
        config: _getConfig(),
        uniqueKey: KEY,
        tinyMceRef: ({
          editor: _editor
        }) => setEditor(_editor),
        content: getEncodedValue(value || ''),
        onChange: (e, _editor) => {
          onChange(getDecodedContent(_editor));
        }
      })
    })
  });
};
export default SubjectField;